import { Navigation as ReusableNavigation } from '@goodfynd/layout';
import { useRouter } from 'next/router';

import type { NavigationProps } from './types';
import { useVendorNavItems } from './useVendorNavItems';

export const Navigation = ({ isCollapsed = false }: NavigationProps) => {
  const { asPath } = useRouter();

  const navItems = useVendorNavItems();

  return (
    <ReusableNavigation
      isCollapsed={isCollapsed}
      items={navItems}
      isSelected={({ href = '' }) => {
        const isSelected = !!href && asPath.startsWith(href);
        return isSelected;
      }}
    />
  );
};
